import range from "lodash/range";
import PropTypes from "prop-types";
import { Form, TextArea } from "semantic-ui-react";
import { Button } from "hireart-components";

import "./net-promoter-score-form.scss";

const RANGE_MIN = 0;
const RANGE_MAX = 10;

const NetPromoterScoreForm = ({
  comment,
  onChange,
  hasSubmitted,
  onSelectScore,
  referralGroups,
  selectedScore,
}) => {
  const numbers = range(RANGE_MIN, RANGE_MAX + 1);

  return (
    <Form className="nps-form">
      <p>
        We hope that you've had a good experience using HireArt! We'd love your
        feedback on your experience so far. We like to keep track of how well
        we're doing, so your time and input are greatly appreciated.
      </p>
      <label className="nps-form-label">
        How likely are you to recommend HireArt to other {referralGroups}?
      </label>
      <div className="nps-range">
        <span className="nps-range-descriptor nps-range-descriptor-low">
          Not Likely
        </span>
        {numbers.map((score) => (
          <Button
            className="nps-range-button"
            disabled={hasSubmitted}
            key={score}
            onClick={() => onSelectScore(score)}
            outlined={selectedScore !== score}
          >
            {String(score)}
          </Button>
        ))}
        <span className="nps-range-descriptor nps-range-descriptor-high">
          Very Likely
        </span>
      </div>

      <label className="nps-form-label" htmlFor="comment">
        Would you like to share more about your experience, or how HireArt might
        improve?
      </label>
      <TextArea
        disabled={hasSubmitted}
        id="comment"
        name="comment"
        onChange={onChange}
        rows={8}
        type="text"
        value={comment}
      />
    </Form>
  );
};

NetPromoterScoreForm.propTypes = {
  comment: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  hasSubmitted: PropTypes.bool.isRequired,
  onSelectScore: PropTypes.func.isRequired,
  referralGroups: PropTypes.string.isRequired,
  selectedScore: PropTypes.number,
};

export default NetPromoterScoreForm;
